import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import SelectDropdown from "../../components-react/SelectDropdown";
import CloseSubmitBtn from "../../common-components/custom-comps/CloseSubmitBtn";
import {
  fetchInventoriesData,
  fetchOfferAttributesData,
  fetchTriggersDaysData,
} from "../../../redux/plans-reducers/plansSlice";
import MultiSelect from "../../components-react/MultiSelect";
import {
  days_30,
  regularPlansDropdown,
  renewal_unpaid,
  trigger_type,
} from "../../common-data/DropdowData";
import "../../../styles/trigger-system/multi-select-dropdown.css";
import { validateTriggerForm } from "../TriggerValidation";

const TriggerForm = ({
  userInfoData,
  isEdit,
  rowData,
  callFunction,
  closeModal,
}) => {
  const dispatch = useDispatch();
  const { postPutLoading } = useSelector((state) => state.common);
  const {
    offerAttributes,
    offerAttributesLoading,
    offerAttributesError,
    inventories,
    inventoriesLoading,
    inventoriesError,
    triggersDays,
    triggersDaysLoading,
    triggersDaysError,
  } = useSelector((state) => state.plans);

  const [allOfferAttributes, setAllOfferAttributes] = useState([]);
  const [allInventories, setAllInventories] = useState([]);
  const [allTriggersDays, setAllTriggersDays] = useState([]);

  const iniFormValues = {
    selectedOfferType: rowData?.type
      ? renewal_unpaid.find((item) => item.value === rowData?.type)
      : "",
    selectedPlanDuration: rowData?.plan_duration
      ? regularPlansDropdown.find(
          (item) => Number(item.value) === Number(rowData?.plan_duration || 0)
        )
      : "",
    selectedCategory: rowData?.category
      ? trigger_type.find((item) => item.value === rowData?.category)
      : "",
    isAllGymAccess: rowData?.is_allgym_access ? true : false,
    isSamePriceRenewal: rowData?.is_same_price_renewal ? true : false,
    isActive: rowData?.status === "active" ? true : false,
  };
  const [formValues, setFormValues] = useState(iniFormValues);
  const iniOfferDaysValues = {
    selectedOfferDayNo: "",
    offerPushContent: "",
    offerEmailContent: "",
    selectedOffers: [],
    extendableDays: "",
    cashbackAmount: "",
    offerVoucherCode: "",
    selectedGoodies: [],
  };
  const [formOfferDaysValues, setFormOfferDaysValues] = useState([
    iniOfferDaysValues,
  ]);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);

  const [triggerDaysOpen, setTriggerDaysOpen] = useState(true);

  const onChangeInput = (e) => {
    const { name, value, type, checked } = e.target;
    const file = type === "file" ? e.target.files[0] : null;

    setIsSubmit(false);

    if (name === "memberMobile" && value.length > 10) {
      return;
    }

    if (name === "processingFee" && Number(value) < 0) {
      return;
    }

    if (name === "isCustomFee") {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: checked,
        processingFee: checked
          ? prevs.processingFee
          : prevs.selectedGym?.info?.gym_transfer_fee || "",
      }));
    } else if (name === "processingFee") {
      const newValue = value;
      const isCustom = parseFloat(newValue) !== "";

      setFormValues((prevs) => ({
        ...prevs,
        [name]: newValue,
        isCustomFee: isCustom,
      }));
    } else {
      setFormValues((prevs) => ({
        ...prevs,
        [name]: type === "checkbox" ? checked : type === "file" ? file : value,
      }));
    }
  };

  const onChangeDropdown = (name, value) => {
    setIsSubmit(false);

    if (name === "selectedGym") {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
        processingFee: value?.info?.gym_transfer_fee || "",
      }));
    } else {
      setFormValues((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const addFormInput = (e) => {
    e.preventDefault();

    setFormOfferDaysValues([...formOfferDaysValues, iniOfferDaysValues]);
  };

  const removeFormInput = (e, index) => {
    e.preventDefault();

    const newFormValues = [...formOfferDaysValues];
    newFormValues.splice(index, 1);
    setFormOfferDaysValues(newFormValues);
  };

  const onChangeInputs = (e, name, index) => {
    const { value } = e.target;

    setFormOfferDaysValues((prev) => {
      const newFormValues = [...prev];
      newFormValues[index][name] = value;
      return newFormValues;
    });
  };

  const onChangeDropdownOfferDays = (name, value, index) => {
    setIsSubmit(false);

    setFormOfferDaysValues((prev) => {
      const newFormValues = [...prev];
      newFormValues[index][name] = value;
      return newFormValues;
    });
  };

  function getOfferAttributes(filters = {}) {
    dispatch(
      fetchOfferAttributesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  const getInventoriesData = (filters = {}) => {
    dispatch(
      fetchInventoriesData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const getTriggersDaysData = (filters) => {
    dispatch(
      fetchTriggersDaysData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  const handleSubmitForm = async (payload) => {
    try {
      const method = isEdit ? "PUT" : "POST";
      const endpoint = isEdit
        ? "/offer/ren_unp_offer/update"
        : "/offer/ren_unp_offer/add";
      const token = userInfoData?.token || "";

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setIsSubmit(false);
        setFormValues(iniFormValues);

        callFunction();
        closeModal();
        toast.success(
          result?.payload?.message || "Offer initiated successfully!"
        );
      } else {
        const errorMessage =
          result?.payload?.data ||
          result?.payload?.message ||
          result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error processing offer:", error);
      toast.error("Failed to process offer");
    }
  };

  const onSumitForm = (e) => {
    e.preventDefault();
    setFormErrors(validateTriggerForm(formValues, formOfferDaysValues));
    setIsSubmit(true);
  };

  useEffect(() => {
    const sendableFilters = {
      status: "active",
      page: 1,
      limit: 1000,
    };

    getOfferAttributes(sendableFilters);
    getInventoriesData(sendableFilters);

    if (isEdit && rowData?.uid) {
      const sendableFilters = {
        status: "active",
        page: 1,
        limit: 1000,
        ren_unp_id: rowData?.uid,
      };

      getTriggersDaysData(sendableFilters);
    }
  }, []);

  useEffect(() => {
    if (
      !offerAttributesLoading &&
      !offerAttributesError &&
      offerAttributes?.status
    ) {
      const offers = offerAttributes?.data?.map((item) => ({
        label: item?.display_label,
        value: item?.uid,
        info: item,
      }));

      setAllOfferAttributes(offers);
    } else {
      setAllOfferAttributes([]);
    }
  }, [offerAttributesLoading, offerAttributesError, offerAttributes]);

  useEffect(() => {
    if (!inventoriesLoading && !inventoriesError && inventories?.status) {
      const inventory = inventories?.data?.map((item) => ({
        label: item?.name,
        value: item?.uid,
        info: item,
      }));

      setAllInventories(inventory);
    } else {
      setAllInventories([]);
    }
  }, [inventoriesLoading, inventoriesError, inventories]);

  useEffect(() => {
    if (
      isEdit &&
      rowData &&
      !triggersDaysLoading &&
      !triggersDaysError &&
      triggersDays?.status
    ) {
      const initialOfferDaysValues = triggersDays?.data?.map((item) => {
        const selectedOffers = [];

        if (item?.voucher) {
          const voucherOffer = allOfferAttributes.find(
            (attr) => attr?.info?.value === "voucher"
          );
          if (voucherOffer) selectedOffers.push(voucherOffer);
        }

        if (item?.cashback) {
          const cashbackOffer = allOfferAttributes.find(
            (attr) => attr?.info?.value === "cash_back"
          );
          if (cashbackOffer) selectedOffers.push(cashbackOffer);
        }

        if (item?.extend_days) {
          const extendDaysOffer = allOfferAttributes.find(
            (attr) => attr?.info?.value === "extent_days"
          );
          if (extendDaysOffer) selectedOffers.push(extendDaysOffer);
        }

        if (item?.offer_goodies?.length > 0) {
          const goodiesOffer = allOfferAttributes.find(
            (attr) => attr?.info?.value === "goodies"
          );
          if (goodiesOffer) selectedOffers.push(goodiesOffer);
        }

        return {
          selectedOfferDayNo: days_30.find(
            (day) => Number(day.value) === Number(item?.days || 0)
          ),
          selectedOffers: selectedOffers,
          extendableDays: item?.extend_days,
          cashbackAmount: item?.cashback,
          offerVoucherCode: item?.voucher,
          selectedGoodies: item?.offer_goodies?.map((goodie) =>
            allInventories.find((inventory) => inventory.value === goodie?.key)
          ),
          offerPushContent: item?.push_content,
          offerEmailContent: item?.email_content,
        };
      });

      setFormOfferDaysValues(initialOfferDaysValues);
    } else {
      setAllTriggersDays([]);
    }
  }, [triggersDaysLoading, triggersDaysError, triggersDays]);

  useEffect(() => {
    if (isSubmit && Object.keys(formErrors)?.length === 0) {
      const payload = {
        type: formValues.selectedOfferType?.value || "",
        plan_duration: formValues.selectedPlanDuration?.value || "",
        category: formValues.selectedCategory?.value || "",
        is_allgym_access: formValues.isAllGymAccess ? 1 : 0,
        is_same_price_renewal: formValues.isSamePriceRenewal ? 1 : 0,
        status: formValues.isActive ? "active" : "inactive",
        days_offers: formOfferDaysValues.map((offerDay) => ({
          days: Number(offerDay.selectedOfferDayNo?.value || 0),
          push_content: offerDay.offerPushContent || "",
          email_content: offerDay.offerEmailContent || "",
          cashback: offerDay.cashbackAmount || "",
          extend_days: offerDay.extendableDays || "",
          voucher: offerDay.offerVoucherCode || "",
          offer_goodies:
            offerDay.selectedGoodies?.map((goodie) => ({
              key: goodie?.value || "",
              value: 1,
            })) || [],
        })),
      };

      if (isEdit) {
        payload.uid = rowData?.uid || "";
      }

      const handleConfirm = async () => {
        handleSubmitForm(payload);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to proceed with this offer?`,
        "Edit Form",
        "Submit Form"
      );
    }
  }, [isSubmit, formErrors]);

  console.log("formErrors=> ", formErrors);

  return (
    <div className="form-container">
      <form className="formContainer">
        <div className="formInputsGrid fourGridSystem">
          <div className="formInputBox">
            <label htmlFor="selectedOfferType" className={`formInputLabel`}>
              offer type <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedOfferType ? "formError" : ""
              }`}>
              <SelectDropdown
                options={renewal_unpaid}
                selectedOption={formValues.selectedOfferType}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedOfferType", selectedValue)
                }
                name="Type"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedPlanDuration" className={`formInputLabel`}>
              plan duration <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedPlanDuration ? "formError" : ""
              }`}>
              <SelectDropdown
                options={regularPlansDropdown}
                selectedOption={formValues.selectedPlanDuration}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedPlanDuration", selectedValue)
                }
                name="Duration"
              />
            </div>
          </div>

          <div className="formInputBox">
            <label htmlFor="selectedCategory" className={`formInputLabel`}>
              offer category <span className="required">*</span>
            </label>

            <div
              className={`commonWrapper ${
                formErrors.selectedCategory ? "formError" : ""
              }`}>
              <SelectDropdown
                options={trigger_type}
                selectedOption={formValues.selectedCategory}
                setSelectedOption={(selectedValue) =>
                  onChangeDropdown("selectedCategory", selectedValue)
                }
                name="Category"
              />
            </div>
          </div>
        </div>

        <div className="formInputsGrid fourGridSystem">
          <div className="grayLine span4"></div>
        </div>

        {/* Trigger Days Header */}
        <div
          className="trigger-ui-header"
          style={{ cursor: "pointer", width: "100%" }}
          onClick={() => setTriggerDaysOpen((prev) => !prev)}>
          <span className="trigger-ui-title">Trigger Days</span>
          <span className="trigger-ui-count">{formOfferDaysValues.length}</span>
          <span
            className="trigger-ui-accordion-toggle"
            style={{ marginLeft: "12px" }}>
            {triggerDaysOpen ? (
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path
                  d="M6 11l3-3 3 3"
                  stroke="#222"
                  strokeWidth="2"
                  fill="none"
                />
              </svg>
            ) : (
              <svg width="18" height="18" viewBox="0 0 18 18">
                <path
                  d="M6 7l3 3 3-3"
                  stroke="#222"
                  strokeWidth="2"
                  fill="none"
                />
              </svg>
            )}
          </span>
        </div>

        {triggerDaysOpen && (
          <>
            <div className="trigger-ui-accordion-list">
              {formOfferDaysValues.map((formInput, index) => (
                <div className="trigger-ui-accordion-item" key={index}>
                  <div className="trigger-ui-accordion-header">
                    <span className="trigger-ui-accordion-title">
                      Template {index + 1}
                    </span>

                    {formOfferDaysValues.length > 1 && (
                      <button
                        className="trigger-ui-remove-btn"
                        onClick={(e) => removeFormInput(e, index)}
                        type="button">
                        X
                      </button>
                    )}
                  </div>

                  <div className="trigger-ui-accordion-content">
                    <div className="formInputsGrid fourGridSystem">
                      <div className="formInputBox">
                        <label
                          htmlFor={`selectedOfferDayNo`}
                          className={`formInputLabel `}>
                          day <span className="required">*</span>
                        </label>

                        <div
                          className={`commonWrapper ${
                            formErrors[index]?.selectedOfferDayNo
                              ? "formError"
                              : ""
                          }`}>
                          <SelectDropdown
                            options={days_30}
                            selectedOption={formInput.selectedOfferDayNo}
                            setSelectedOption={(selectedValue) =>
                              onChangeDropdownOfferDays(
                                "selectedOfferDayNo",
                                selectedValue,
                                index
                              )
                            }
                            name="day"
                          />
                        </div>
                      </div>

                      <div className={`formInputBox span2`}>
                        <label
                          htmlFor="selectedOffers"
                          className={`formInputLabel`}>
                          offers <span className="required">*</span>
                        </label>

                        <div
                          className={`commonWrapper no-border multi-select multi-show-option ${
                            formErrors[index]?.selectedOffers ? "error" : ""
                          }`}>
                          <MultiSelect
                            options={allOfferAttributes}
                            state={formInput.selectedOffers}
                            setState={(selectedValue) =>
                              onChangeDropdownOfferDays(
                                "selectedOffers",
                                selectedValue,
                                index
                              )
                            }
                            name="select multiple from the list"
                            preventKeyboardOpen={false}
                            isShowList={true}
                          />
                        </div>
                      </div>

                      {formInput.selectedOffers?.some(
                        (offer) => offer?.info?.value === "extent_days"
                      ) && (
                        <div className="formInputBox">
                          <label
                            htmlFor="extendableDays"
                            className={`formInputLabel`}>
                            Extendable Days <span className="required">*</span>
                          </label>

                          <input
                            type="number"
                            placeholder="Enter Days"
                            className={`formInput ${
                              formErrors[index]?.extendableDays
                                ? "formError"
                                : ""
                            }`}
                            name="extendableDays"
                            value={formInput.extendableDays}
                            onChange={(e) =>
                              onChangeInputs(e, "extendableDays", index)
                            }
                            min={0}
                          />
                        </div>
                      )}

                      {formInput.selectedOffers?.some(
                        (offer) => offer?.info?.value === "cash_back"
                      ) && (
                        <div className="formInputBox">
                          <label
                            htmlFor="cashbackAmount"
                            className={`formInputLabel`}>
                            Cashback Amount <span className="required">*</span>
                          </label>

                          <input
                            type="number"
                            placeholder="Enter Amount"
                            className={`formInput ${
                              formErrors[index]?.cashbackAmount
                                ? "formError"
                                : ""
                            }`}
                            name="cashbackAmount"
                            value={formInput.cashbackAmount}
                            onChange={(e) =>
                              onChangeInputs(e, "cashbackAmount", index)
                            }
                            min={0}
                          />
                        </div>
                      )}

                      {formInput.selectedOffers?.some(
                        (offer) => offer?.info?.value === "voucher"
                      ) && (
                        <div className="formInputBox">
                          <label
                            htmlFor="offerVoucherCode"
                            className={`formInputLabel`}>
                            Voucher Code <span className="required">*</span>
                          </label>

                          <input
                            type="text"
                            placeholder="Enter Code"
                            className={`formInput ${
                              formErrors[index]?.offerVoucherCode
                                ? "formError"
                                : ""
                            }`}
                            name="offerVoucherCode"
                            value={formInput.offerVoucherCode}
                            onChange={(e) =>
                              onChangeInputs(e, "offerVoucherCode", index)
                            }
                          />
                        </div>
                      )}

                      {formInput.selectedOffers?.some(
                        (offer) => offer?.info?.value === "goodies"
                      ) && (
                        <div
                          className={`formInputBox ${
                            formInput.selectedGoodies?.length > 2 ? "span2" : ""
                          }`}>
                          <label
                            htmlFor="selectedGoodies"
                            className={`formInputLabel`}>
                            Goodies <span className="required">*</span>
                          </label>
                          <div
                            className={`commonWrapper no-border multi-select multi-show-option ${
                              formErrors[index]?.selectedGoodies ? "error" : ""
                            }`}>
                            <MultiSelect
                              options={allInventories}
                              state={formInput.selectedGoodies}
                              setState={(selectedValue) =>
                                onChangeDropdownOfferDays(
                                  "selectedGoodies",
                                  selectedValue,
                                  index
                                )
                              }
                              name="select multiple from the list"
                              preventKeyboardOpen={false}
                              isShowList={true}
                            />
                          </div>
                        </div>
                      )}

                      <div className="formInputBox span2">
                        <label
                          htmlFor={`offerPushContent`}
                          className={`formInputLabel `}>
                          Offer Push Content <span className="required">*</span>
                        </label>

                        <textarea
                          name="offerPushContent"
                          className={`formInput ${
                            formErrors[index]?.offerPushContent
                              ? "formError"
                              : ""
                          }`}
                          placeholder="Enter Offer Push Content"
                          value={formInput.offerPushContent}
                          onChange={(e) =>
                            onChangeInputs(e, "offerPushContent", index)
                          }></textarea>
                      </div>

                      <div className="formInputBox span2">
                        <label
                          htmlFor={`offerEmailContent`}
                          className={`formInputLabel `}>
                          Offer Email Content{" "}
                          <span className="required">*</span>
                        </label>

                        <textarea
                          name="offerEmailContent"
                          className={`formInput ${
                            formErrors[index]?.offerEmailContent
                              ? "formError"
                              : ""
                          }`}
                          placeholder="Enter Offer Push Content"
                          value={formInput.offerEmailContent}
                          onChange={(e) =>
                            onChangeInputs(e, "offerEmailContent", index)
                          }></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
            <div
              className="trigger-ui-add-more-container"
              style={{ width: "100%" }}>
              <button
                className="trigger-ui-add-more-btn"
                onClick={addFormInput}
                type="button">
                + Add More
              </button>
            </div>
          </>
        )}

        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox checkbox-wrapper span2">
            <div className="flex-box">
              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isAllGymAccess"
                  checked={formValues.isAllGymAccess}
                  onChange={onChangeInput}
                />
                all gym access
              </label>

              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isSamePriceRenewal"
                  checked={formValues.isSamePriceRenewal}
                  onChange={onChangeInput}
                />
                allow renewal in same price
              </label>

              <label className="checkboxLabel">
                <input
                  type="checkbox"
                  name="isActive"
                  checked={formValues.isActive}
                  onChange={onChangeInput}
                />
                Active
              </label>
            </div>
          </div>
        </div>

        <CloseSubmitBtn
          closeLabel="Cancel"
          submitLabel="Submit"
          onClose={closeModal}
          onSubmit={onSumitForm}
          isLoading={postPutLoading}
        />
      </form>
    </div>
  );
};

export default TriggerForm;
